import React from 'react';

/**
 * Lightweight PageLoader — Pure CSS fallback for route-level React.lazy Suspense boundaries.
 * Zero external library dependencies (no motion, no lucide) so it displays instantly
 * before any secondary vendor chunks are downloaded.
 */
export const PageLoader: React.FC<{ message?: string }> = ({ message = 'Loading workspace...' }) => {
  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-[var(--bg-app,#f8fafc)] text-slate-800 dark:text-white"
    >
      <div className="relative flex items-center justify-center">
        {/* Outer subtle glow */}
        <div className="absolute h-16 w-16 rounded-full bg-[var(--brand-primary,#4f46e5)] opacity-20 blur-xl animate-pulse" />
        
        {/* Spinning indicator */}
        <div className="h-10 w-10 rounded-full border-3 border-slate-200 dark:border-slate-800 border-t-[var(--brand-primary,#4f46e5)] animate-spin" />
      </div>

      <p className="mt-4 text-xs font-bold tracking-wide text-slate-500 dark:text-slate-400 uppercase">
        {message}
      </p>
    </div>
  );
};
